import Vue from 'vue';
import querystring from 'querystring';
import * as Publicaciones from '@lib/MercadoLibre/Publicaciones';
import * as Articulos from '@lib/Articulos';
import { Publicacion } from '@lib/MercadoLibre/Publicaciones';
import { Watch } from 'vue-property-decorator';
import { Paginacion, Wait } from '@/__env/ext';
import { Utiles } from '@env/pluggins/event-bus';
import { SignalDispatcher } from 'strongly-typed-events';
import { VistaBase, FiltrosBase } from '@/components/a-interfaz/a-controlador';
import router from '@/__env/router.index';
import { type } from 'os';
import { PresetImportarExcel } from '@/__env/lib/Ventas/ImportarExcel/Presets/Preset.nav';
import { Pedido } from '@/__env/lib/Ventas/Pedidos';
import { ImportarPedidoDesdeExcel } from '@/__env/lib/Ventas/Pedidos/ImportarDesdeExcel';
import * as Envios from '@/__env/lib/Ventas/Envios';
import * as Pedidos from '@/__env/lib/Ventas/Pedidos';

export class ControladorSeccion
{

    public Pedido: Pedido = null;
    public Pedidos: Pedido[] = [];

    async Iniciar( datos: Record<string, string>[], opciones: { tipo: Pedidos.Tipos; } )
    {

        for ( let data of datos )
        {
            let pp = await ImportarPedidoDesdeExcel( data, opciones.tipo );
            if ( pp )
                this.Pedidos.push( pp );
        }
        if ( this.Pedidos.hasRows() )
        {
            this.Pedido = this.Pedidos[0];
        } else
        {
            this.Pedido = new Pedido();
        }

        this.Vista.Estado = 'iniciado';
    }


    public PedidoActual: number = 0;
    public esUltimo()
    {
        return ( this.PedidoActual + 1 ) == this.Pedidos.length;
    }

    public async GuardarYContinuar()
    {

        this.Vista.Estado = 'cargando';

        let e = await this.Pedido.Cliente.save();
        if ( !e )
        {
            Utiles.Notificaciones.Error( 'Error al guardar el cliente' );
            this.Vista.Estado = 'iniciado';
            return;
        }
        e = await this.Pedido.Envio.save();
        if ( !e )
        {
            Utiles.Notificaciones.Error( 'Error al guardar el envío' );
            this.Vista.Estado = 'iniciado';
            return;
        }

        for ( let pago of this.Pedido.Pagos )
        {
            pago.Cliente.Id = this.Pedido.Cliente.Id;
            e = await pago.save();
            if ( !e )
            {
                Utiles.Notificaciones.Error( 'Error al guardar el pago' );
                this.Vista.Estado = 'iniciado';
                return;
            }
        }
        

        e = await this.Pedido.save();
        if ( !e )
        {
            Utiles.Notificaciones.Error( 'Error al guardar el pedido' );
            this.Vista.Estado = 'iniciado';
            return;
        }

        e = await this.Pedido.AgregarPagos( this.Pedido.Pagos.map( x => x.Id.toString() ) );
        if ( !e )
        {
            Utiles.Notificaciones.Error( 'Error al guardar el pago' );
            this.Vista.Estado = 'iniciado';
            return;
        }

        for ( let ob of this.Pedido.Observaciones )
        {
            ob.Pedido = this.Pedido.Id;
            await ob.save();
        }

        if ( !this.esUltimo() )
        {
            this.PedidoActual++;
            this.Pedido = this.Pedidos[this.PedidoActual];
        }
        await Wait(500)
        this.Vista.Estado = 'iniciado';
    }

    public Vista: Vista = new Vista();
    private _onRecargar = new SignalDispatcher();
    public get onRecargar() { return this._onRecargar.asEvent(); }


}

export class Vista extends VistaBase
{

}

const Controlador = new ControladorSeccion();
export { Controlador };

